var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Card',[_c('Table',{staticStyle:{"margin-top":"20px"},attrs:{"border":"","loading":_vm.loading,"columns":_vm.columns,"data":_vm.orders,"changePage":_vm.changePage},on:{"on-row-click":_vm.onRowClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }